import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import Section from "../section/section"
import Badge from "../badge/badge"
import Quote from "../quotes/quote"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { QuotesWrapperFlex } from "./quote.styled"

const DoctorQuotes = ({ data }) => {
  const { heading, badge, quotes, legal, mobileQuoteDisplay = "row" } = data

  return (
    <Section>
      <Flex
        flexWrap="wrap"
        justifyContent={["auto", null, badge ? "space-between" : "center"]}
        alignItems={["auto", null, "center"]}
        mb={[0, 0, 40, 80]}
        px={[0, 0, 16, 24]}
      >
        <Box width={[1, null, "auto"]} mb={[32, 32, 0]}>
          <TextElementNova
            text={heading}
            element="h4"
            className="Title-20-Super-Normal text-center doctor-quotes-heading mx-auto"
          />
        </Box>

        {badge && (
          <Box mb={[32, 32, 0]} width={badge.widths} mx={["auto", null, 0]}>
            <Badge />
          </Box>
        )}
      </Flex>

      <QuotesWrapperFlex
        className={`${quotes.length === 1 ? "single-quote" : ""}`}
        flexWrap="wrap"
        mb={24}
      >
        {quotes.map((quote, i) => {
          return (
            <Box width={[1, 1, 1, 1 / quotes.length]} key={i}>
              <Quote
                data={quote}
                mobileColumnDisplay={mobileQuoteDisplay === "column"}
                isFirst={i === 0}
                isLast={i === quotes.length - 1}
                className="quote"
              />
            </Box>
          )
        })}
      </QuotesWrapperFlex>

      {legal ? (
        <TextElementNova
          text={legal}
          element="p"
          className="Caption-10-Dia-Normal text-nova-transparency-black-60 text-center"
        />
      ) : null}
    </Section>
  )
}

export default DoctorQuotes
